// extracted by mini-css-extract-plugin
module.exports = {"root":"AddUser_root__2-owm","dialogRoot":"AddUser_dialogRoot__fo-qC","modalPrimaryButton":"AddUser_modalPrimaryButton__1cnvw","textRoot":"AddUser_textRoot__3a123"};